module.exports = __webpack_public_path__ + "static/media/321perfect.b3176b69.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/workout/321perfect.mp3
// module id = 2031
// module chunks = 0